export const parseErrorJson = (errorMessage) => {
    try {
        // Find the start and end positions of the JSON part
        const jsonStartIndex = errorMessage.indexOf('{');
        const jsonEndIndex = errorMessage.lastIndexOf('}');

        // Ensure both braces are found and in the correct order
        if (jsonStartIndex !== -1 && jsonEndIndex !== -1 && jsonEndIndex > jsonStartIndex) {
            const jsonString = errorMessage.slice(jsonStartIndex, jsonEndIndex + 1);
            return JSON.parse(jsonString);  // Parse the JSON string
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const otpSuccess = {
    code: 0,
    status: "success",
    title: "A One-Time Password has been sent",
    message: "You will receive an email with the OTP if you are registered."
};

export const otpInvalidError = {
    code: 0,
    status: "error",
    title: "Invalid OTP",
    message: "The OTP entered is incorrect. Please re-enter the OTP or click Resend OTP for a new OTP."
};

export const defaultError = {
    code: 0,
    status: "error",
    title: "Login Failed",
    message: "Unable to login at this time. Please try again later or contact your administrator."
};